import FormValidation from '../form-validation';

class TemplateDownloads {
  private elScope: HTMLElement;

  private elScollArea: HTMLElement;

  private elForm: HTMLFormElement;

  private elButtonHome: HTMLElement;

  private elButtonOpen: HTMLButtonElement;

  private isLocked = false;

  private endpoint = '/api/v1/forms/download_document_request';

  private elButtonTabs: NodeListOf<HTMLButtonElement>;

  private elInputs: NodeListOf<HTMLInputElement>;

  private elTextArea: HTMLTextAreaElement;

  private elInputCompany: HTMLInputElement;

  private elCheckTerms: HTMLInputElement;

  private formValidation: FormValidation;

  constructor(elScope: HTMLElement) {
    this.elScope = elScope

    this.elForm = this.elScope.querySelector('form') as HTMLFormElement;
    this.endpoint = this.elForm.action;

    this.elButtonHome = this.elScope.querySelector('.js-downloads-form-btb') as HTMLElement;
    this.elScollArea = this.elScope.querySelector('#popup-download-file') as HTMLElement;
    this.elButtonOpen = this.elScope.querySelector('button[data-target="popup-download-file"]') as HTMLButtonElement;
    this.elButtonTabs = this.elScope.querySelectorAll('button.js-tab-switch') as NodeListOf<HTMLButtonElement>;
    this.elInputs = this.elForm.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
    this.elTextArea = this.elForm.querySelector('textarea') as HTMLTextAreaElement;
    this.elInputCompany = this.elForm.querySelector('input[name="company"]') as HTMLInputElement;
    this.elCheckTerms = this.elForm.querySelector('#popup-download-terms-1') as HTMLInputElement;
  }

  init () {
    this.elButtonTabs[0].addEventListener('click', () => this.toggleInputCompany(false));
    this.elButtonTabs[1].addEventListener('click', () => this.toggleInputCompany(true));
    this.elButtonOpen.addEventListener('click', () => this.onOpen());
    this.elButtonHome.addEventListener('click', () => this.onOpen());

    this.formValidation = new FormValidation(
      this.elForm,
      this.handlerFormSubmit.bind(this),
      this.handlerError.bind(this)
    );
    this.formValidation.init();
  }

  private onOpen() {
    const { elForm } = this;
    this.cleanInputs();

    elForm.dataset.status = 'home';
  }

  private toggleInputCompany(isActive: boolean) {
    const { elInputCompany } = this;

    elInputCompany.value = '';
    if (isActive) {
      elInputCompany.setAttribute('required', '');
    } else {
      elInputCompany.removeAttribute('required');
    }
  }

  private async handlerFormSubmit() {
    if (this.isLocked) return;

    this.setLock();
    const result = await this.submitData();
    if (result.success) {
      this.cleanInputs();
      this.elForm.dataset.status = 'ty';
    } else {
      this.elForm.dataset.status = 'error';
    }
    this.setLock(false);
  }

  private handlerError() {
    const elError = this.elForm.querySelector('.has-error');
    if (elError) {
      const { elScollArea } = this;
      const top = elError.getBoundingClientRect().top + elScollArea.scrollTop - 50;
      elScollArea.scrollTo({top});
      (elError as HTMLElement).focus();
    }
  }

  private setLock(isLocked: boolean = true) {
    this.isLocked = isLocked;
    this.elForm.classList.toggle('is-sending', this.isLocked);
  }

  private cleanInputs() {
    const { elInputs, elTextArea } = this;

    elInputs.forEach((el) => {
      if (!el.classList.contains('prefilled')) {
        el.value = '';
      }
    });

    if (!elTextArea.classList.contains('prefilled')) {
      elTextArea.value = '';
    }
  }

  protected async submitData(): Promise<{success: boolean, response: any}> {
    const { endpoint } = this;
    let success = false;
    let response = 'error';

    const data = new FormData(this.elForm);
    if (this.elCheckTerms.checked === true) {
      data.set('terms_accepted', 'true');
    }
    await fetch(endpoint, {
      method: 'POST',
      body: data,
    })
    .then((res) => res.json())
    .then(res => {
      if (res.success == true || res.success === 'true') {
        success = true;
      }
    })
    .catch((error) => {
      console.warn(error);
      response = 'error undefined';
    });

    return { success, response };
  }
}

export default TemplateDownloads;
